import { isEmpty } from 'lodash';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import {
  CartResponse,
  CartRewardData,
} from 'src/items-list/business-logic/service/interfaces/cart-response';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { popupAsyncMessage } from '../../messages/business-logic/popup-message';
import { store } from 'src/common/redux/configure-store';
import { TransactionActions } from 'src/common/redux/reducers/transaction-reducer';

export const getCartPromotionMessage = async (cart: CartResponse): Promise<void> => {
  if (cart.rewards) {
    for (const reward of cart.rewards) {
      const promotionId: string = reward?.promotionId || '';
      const alreadyShownPromotions = store.getState().transaction.shownPromotions || [];
      //ignore message if message is already shown for this promotionId
      if (alreadyShownPromotions?.indexOf(promotionId) >= 0) {
        continue;
      }
      if (promotionId) {
        store.dispatch(TransactionActions.addShownPromotion(promotionId));
      }
      if (reward.message && !isEmpty(reward.message)) {
        await sendPromotionPopupMessage(reward);
      }
    }
  }
};

const sendPromotionPopupMessage = async (reward: CartRewardData): Promise<void> => {
  let promotionMessage: IMessageModal;

  const programNotEligible = ['AMS4504', 'Program is not eligible'];
  if (programNotEligible.some(str => reward.message?.body?.includes(str))) {
    promotionMessage = {
      message: 'RewardsNotApplied',
      type: EmeraldDialogTypes.Info,
      subMessage: 'LoyaltyCustomerRemoved',
    };
  } else {
    promotionMessage = {
      message: reward.message?.caption || reward.message?.body,
      type: EmeraldDialogTypes.Info,
      subMessage: reward.message?.caption ? reward.message.body : '',
    };
  }
  await popupAsyncMessage(promotionMessage);
};
